import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, BehaviorSubject } from 'rxjs';
import { catchError, mergeMap, switchMap, finalize, filter, take } from 'rxjs/operators';
import { AuthenService } from '../services/authen.service';
import { HttpService } from './http.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    isRefreshingToken: boolean = false;
    tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    constructor(private auth: AuthenService, private http: HttpService)
    {
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        //console.log('intercept: ' + this.auth.tokenJWT);
        //console.log('intercept: ');

        if (this.auth.tokenJWT != null) {
            return next.handle(this.addTokenToRequest(request, this.auth.tokenJWT));

            /*
            return next.handle(this.addTokenToRequest(request, this.auth.tokenJWT)).pipe(
                catchError(err => {
                    if (err instanceof HttpErrorResponse) {
                        switch (err.status) {
                            case 401:
                                return this.handle401Error(request, next);
                            default: {
                                console.log('token expired');
                                console.log(err.status);
                            }
                        }
                    }
                    else
                        return Observable.throw(err);
                })
            );*/
        }
        else {
            console.log('intercept: no token');
            return next.handle(request);
        }
    }

    private addTokenToRequest(request: HttpRequest<any>, token: string): HttpRequest<any> {
        //console.log(token);
        return request.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
        console.log('handle401Error');

        if (!this.isRefreshingToken) {
            this.isRefreshingToken = true;

            // Reset here so that the following requests wait until the token
            // comes back from the refreshToken call.
            this.tokenSubject.next(null);

            let data = new FormData();
            data.append('jwt', this.auth.tokenJWT);
            data.append('refToken', this.auth.refToken);

            return this.http.pipe('api/Authen/RefreshToken', data).pipe(
                switchMap(res => {
                    if (res.HasError) {
                        console.log('RefreshToken failed');
                    }
                    else {
                        console.log('RefreshToken success');
                        console.log(res.Result);

                        this.auth.setTokens(res.Result);
                        this.tokenSubject.next(this.auth.tokenJWT);;

                        return next.handle(this.addTokenToRequest(request, this.auth.tokenJWT));
                    }
                }),
                catchError(err => {
                    console.log('RefreshToken system error');
                    return Observable.throw(err);
                }),
                finalize(() => {
                    console.log('RefreshToken finished');
                    this.isRefreshingToken = false;
                })
            );
        }
        else {
            this.isRefreshingToken = false;

            return this.tokenSubject
                .pipe(filter(token => token != null),
                    take(1),
                    switchMap(token => {
                        return next.handle(this.addTokenToRequest(request, token));
                    }));
        }
    }
}
